module.exports = __webpack_public_path__ + "media/images/undraw_building_website-01d22586.png";